export interface RoleBasedAccessUiPb {
  roleByProperty?: RoleUiPb[];
}

export interface RoleUiPb {
  topLevelEntityId?: string;
  role?: RoleUiEnum[];
}

export enum RoleUiEnum {
  HOTEL_MANAGER = 'HOTEL_MANAGER',
  FINANACE_MANAGER = 'FINANACE_MANAGER',
  REVENUE_MANAGER = 'REVENUE_MANAGER',
  RESERVATION_MANAGER = 'RESERVATION_MANAGER',
  SUPER_USER = 'SUPER_USER',
  PRICE_MANAGER = 'PRICE_MANAGER',
  INVENTORY_MANAGER = 'INVENTORY_MANAGER',
}

export enum DepartmentUiEnum {
  CX_AGENTS = 'CX_AGENTS',
  FINANACE = 'FINANCE',
  MARKETING = 'MARKETING',
  OPERATIONS = 'OPERATIONS',
  RESERVATIONS = 'RESERVATIONS',
  REVENUE = 'REVENUE',
  SALES = 'SALES',
  TECH = 'TECH',
}


export enum GridRoleUiEnum {
  REVENUE_MANAGER = 'REVENUE_MANAGER',
  PRICE_MANAGER = 'PRICE_MANAGER',
  INVENTORY_MANAGER = 'INVENTORY_MANAGER',
}